import ApiService from '../api-service/ApiService';

const SEQUENCE_BASE_URL = '/sequence';

const SequenceService = {
    // Get all sequences
    getSequences: (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return ApiService.getData(`${SEQUENCE_BASE_URL}/list?${queryString}`);
    },

    // Get single sequence by ID
    getSequence: (id) =>
        ApiService.getData(`${SEQUENCE_BASE_URL}/${id}`),

    // Create new sequence
    createSequence: (data) =>
        ApiService.postData(`${SEQUENCE_BASE_URL}/create`, data),

    // Update sequence
    updateSequence: (id, data) =>
        ApiService.putData(`${SEQUENCE_BASE_URL}/${id}`, data),

    // Delete sequence (soft delete)
    deleteSequence: (id) =>
        ApiService.deleteData(`${SEQUENCE_BASE_URL}/${id}`),

    // Duplicate sequence
    duplicateSequence: (id) =>
        ApiService.postData(`${SEQUENCE_BASE_URL}/${id}/duplicate`, {}),

    // Enroll opportunities in sequence
    enrollOpportunities: (data) =>
        ApiService.postData(`${SEQUENCE_BASE_URL}/enroll`, data),

    // Get enrollment status for an opportunity
    getEnrollmentStatus: (opportunityId) =>
        ApiService.getData(`${SEQUENCE_BASE_URL}/enrollment/${opportunityId}`),

    // Get all enrollments for a sequence
    getSequenceEnrollments: (sequenceId) =>
        ApiService.getData(`${SEQUENCE_BASE_URL}/${sequenceId}/enrollments`),

    // Pause enrollment
    pauseEnrollment: (enrollmentId) =>
        ApiService.postData(`${SEQUENCE_BASE_URL}/enrollment/${enrollmentId}/pause`, {}),

    // Resume enrollment
    resumeEnrollment: (enrollmentId) =>
        ApiService.postData(`${SEQUENCE_BASE_URL}/enrollment/${enrollmentId}/resume`, {}),

    // Exit enrollment
    exitEnrollment: (enrollmentId, exitReason) =>
        ApiService.postData(`${SEQUENCE_BASE_URL}/enrollment/${enrollmentId}/exit`, { exitReason }),

    // Get next action for extension (used by LinkedIn extension)
    getNextAction: (opportunityId) =>
        ApiService.getData(`${SEQUENCE_BASE_URL}/next-action/${opportunityId}`),

    // Mark step as executed (called from extension)
    markStepExecuted: (data) =>
        ApiService.postData(`${SEQUENCE_BASE_URL}/mark-executed`, data),
};

export default SequenceService;
